import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-politic-and-quality',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgForOf
  ],
  templateUrl: './politic-and-quality.component.html',
  styleUrl: './politic-and-quality.component.css'
})
export class PoliticAndQualityComponent {

  objetivos = [
    {
      objetivo: 'Brindar servicios médicos ambulatorios integrales que proporcionen bienestar a nuestros usuarios en cumplimiento de los requisitos aplicables.',
    },
    {
      objetivo: 'Realizar procesos de control para el cumplimiento de los requisitos aplicables de nuestros clientes.'
    },
    {
      objetivo: 'Contar con personal competente para la prestación de servicios médicos de excelencia.'
    },
    {
      objetivo: 'Contar con insumos, equipos e infraestructura necesarios para brindar servicios médicos ambulatorios integrales.'
    },
    {
      objetivo: 'Optimizar los recursos de la organización soportando el crecimiento sostenible y vanguardista del servicio.'
    },
    {
      objetivo: 'Cumplir con los requisitos legales y reglamentarios aplicables a la organización.'
    },
    {
      objetivo: 'Optimizar los procesos para el crecimiento continuo y fidelización del público objetivo, la comunicación e imagen de la organización.'
    },
    {
      objetivo: 'Contar con los recursos tecnológicos (Hardware y Software) que faciliten la gestión médica y accesibilidad con los usuarios.'
    }
    ]

}
